/**
 * Standard WordPress i18n helpers injected into hit/stats templates as
 * { __, _n, sprintf }. These are the raw wp.i18n functions — each takes a TEXT
 * DOMAIN argument, exactly like PHP's __()/_n().
 *
 * The domain is the template author's choice, and that's the point:
 *   - The plugin's OWN built-in templates use the plugin domain, e.g.
 *       __( 'no results', 'tangible-searchsync' )
 *   - A THEME's custom template uses the THEME's domain, e.g.
 *       __( 'of', 'onlit-algolia' )
 *     so those strings live in the theme's language files and are owned by the
 *     site, not baked into (and wiped by) the plugin.
 *
 * For a domain to resolve, its translations must be registered against the
 * 'algolia-components-js' script handle. The plugin registers its own domain;
 * themes register theirs via the `tgbl_ss_script_i18n_domains` PHP filter.
 *
 * Backed by wp.i18n (the registry wp_set_script_translations() populates). Falls
 * back to the source string when wp.i18n is unavailable, so templates never break
 * on a non-multilingual site.
 */

const wpI18n =
  typeof window !== 'undefined' && window.wp && window.wp.i18n ? window.wp.i18n : null;

export const __ = ( text, domain ) => ( wpI18n ? wpI18n.__( text, domain ) : text );

export const _n = ( single, plural, number, domain ) =>
  wpI18n ? wpI18n._n( single, plural, number, domain ) : ( number === 1 ? single : plural );

export const sprintf = ( format, ...args ) =>
  wpI18n ? wpI18n.sprintf( format, ...args ) : format;
